import React from 'react';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import {
  ACCENT_PRESETS,
  TONE_PRESETS,
  applyAccentPreset,
  getStoredAccent,
  getStoredTone,
  setArchiveTone,
} from '../../utils/archivePersonalization';

/**
 * Controlled personalisation — accent + archive tone preset (localStorage).
 */
export function ArchivePersonalizationSettings({ className }) {
  const [accent, setAccent] = React.useState(getStoredAccent);
  const [tone, setTone] = React.useState(getStoredTone);

  return (
    <div className={className} data-testid="archive-personalization">
      <p className="text-sm font-medium mb-1">Archive appearance</p>
      <p className="text-xs text-muted-foreground mb-4 leading-relaxed">
        Choose a curated accent for highlights and sidebar details. Colours stay within the MyLegacyBridge palette.
      </p>
      <div className="grid gap-4 sm:grid-cols-2">
        <div className="space-y-2">
          <Label className="text-xs text-muted-foreground">Accent</Label>
          <Select
            value={accent}
            onValueChange={(v) => {
              setAccent(v);
              applyAccentPreset(v);
            }}
          >
            <SelectTrigger className="h-9">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {ACCENT_PRESETS.map((p) => (
                <SelectItem key={p.id} value={p.id}>
                  {p.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-2">
          <Label className="text-xs text-muted-foreground">Archive tone</Label>
          <Select
            value={tone}
            onValueChange={(v) => {
              setTone(v);
              setArchiveTone(v);
            }}
          >
            <SelectTrigger className="h-9">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {TONE_PRESETS.map((p) => (
                <SelectItem key={p.id} value={p.id}>
                  {p.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <p className="text-[11px] text-muted-foreground">
            {TONE_PRESETS.find((p) => p.id === tone)?.hint}
          </p>
        </div>
      </div>
    </div>
  );
}

export default ArchivePersonalizationSettings;
